module.exports = __webpack_public_path__ + "static/img/yytx39.f4a1ac5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx39.png
// module id = 906
// module chunks = 0